export function deepEqual(obj1, obj2)
{
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function shallowEqual(objA: mixed, objB: mixed): boolean {
  if (objA === objB) {
    return true;
  }

  if (
    typeof objA !== "object" ||
    objA === null ||
    typeof objB !== "object" ||
    objB === null
  ) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i])) {
      return false;
    } else if (
      objA[keysA[i]] !== objB[keysA[i]] &&
      typeof objA[keysA[i]] === "object" &&
      typeof objB[keysA[i]] === "object"
    ) {
      if (!shallowEqual(objA[keysA[i]], objB[keysA[i]])) {
        return false;
      }
    } else if(objA[keysA[i]] !== objB[keysA[i]]){
      return false
    }
  }

  return true;
}

export default function(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}



// WEBPACK FOOTER //
// ./src/computationApps/utils/shallowCompare.js